export enum MaterialNameWhitelistAmountValidator {
  MUD = 'Mud',
  TAPE = 'Tape',
}
